"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.multiPodCreate = exports.podifySafe = exports.enableController = exports.getControllerFromModules = exports.createPod = void 0;
var ethers_1 = require("ethers");
var contracts_1 = require("@orcaprotocol/contracts");
var ensjs_1 = require("@ensdomains/ensjs");
var config_1 = require("./config");
var utils_1 = require("./lib/utils");
var transaction_service_1 = require("./lib/services/transaction-service");
var create_safe_transaction_1 = require("./lib/services/create-safe-transaction");
function createAddressPointer(number) {
    var cutLength = String(number).length;
    return ethers_1.ethers.constants.AddressZero.slice(0, 42 - cutLength) + number;
}
function getImageUrl(nextPodId) {
    var baseUrl = "https://orcaprotocol-nft.vercel.app".concat(config_1.config.network === 5 ? '/assets/testnet/' : '/assets/');
    return "".concat(baseUrl).concat(nextPodId.toString(16).padStart(64, '0'), "-image");
}
/**
 * Creates a safe and podifies it.
 * If a signer is not provided, instead it returns an unsigned transaction.
 * @param args.members - Array of pod member addresses
 * @param args.threshold - Voting threshold
 * @param args.admin - Optional pod admin
 * @param args.name - ENS label for safe, i.e., 'orca-core'. Do not add the pod.eth/pod.xyz suffix
 * @param signer - Optional signer
 */
function createPod(args, signer) {
    return __awaiter(this, void 0, void 0, function () {
        var members, admin, MemberToken, expectedPodId, Controller, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    members = args.members.map(ethers_1.ethers.utils.getAddress);
                    admin = args.admin ? ethers_1.ethers.utils.getAddress(args.admin) : ethers_1.ethers.constants.AddressZero;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    MemberToken = (0, utils_1.getMetropolisContract)('MemberToken', config_1.config.provider);
                    return [4 /*yield*/, MemberToken.getNextAvailablePodId()];
                case 2:
                    expectedPodId = (_a.sent()).toNumber();
                    Controller = (0, utils_1.getMetropolisContract)('ControllerLatest', signer);
                    if (signer)
                        return [2 /*return*/, Controller.createPod(members, args.threshold, admin, (0, ensjs_1.labelhash)(args.name), "".concat(args.name, ".").concat(config_1.config.network === 1 ? 'pod.xyz' : 'pod.eth'), expectedPodId, getImageUrl(expectedPodId))];
                    return [4 /*yield*/, Controller.populateTransaction.createPod(members, args.threshold, admin, (0, ensjs_1.labelhash)(args.name), "".concat(args.name, ".").concat(config_1.config.network === 1 ? 'pod.xyz' : 'pod.eth'), expectedPodId, getImageUrl(expectedPodId))];
                case 3: return [2 /*return*/, (_a.sent())];
                case 4:
                    err_1 = _a.sent();
                    return [2 /*return*/, (0, utils_1.handleEthersError)(err_1)];
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.createPod = createPod;
/**
 * Returns the deployment of a controller from a safe's modules, if it exists, otherwise returns null.
 * @param safeOrModules - safe address or list of modules
 * @returns bool
 */
function getControllerFromModules(safeOrModules) {
    return __awaiter(this, void 0, void 0, function () {
        var modules, controller;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(typeof safeOrModules === 'string')) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, transaction_service_1.getSafeInfo)(safeOrModules)];
                case 1:
                    (modules = (_a.sent()).modules);
                    return [3 /*break*/, 3];
                case 2:
                    modules = safeOrModules;
                    _a.label = 3;
                case 3:
                    controller = null;
                    modules.forEach(function (module) {
                        try {
                            // This throws if the address does not match a Controller deployment.
                            controller = (0, contracts_1.getControllerByAddress)(module, config_1.config.network);
                            // If the above didn't throw, then we've found an Orca module.
                        }
                        catch (_a) {
                            // do nothing
                        }
                    });
                    return [2 /*return*/, controller];
            }
        });
    });
}
exports.getControllerFromModules = getControllerFromModules;
/**
 * Creates a SafeTx on a safe to enable the latest Controller as a module.
 *
 * @param safe - Safe address
 * @param signer
 * @throws If a Controller module is already enabled. If you are attempting to upgrade versions, use `Pod.migratePodToLatest`.
 */
function enableController(safe, signer) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var sender, _b, owners, modules, latestModule, safeTx, err_2;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, signer.getAddress()];
                case 1:
                    sender = _c.sent();
                    return [4 /*yield*/, (0, transaction_service_1.getSafeInfo)(safe)];
                case 2:
                    _b = _c.sent(), owners = _b.owners, modules = _b.modules;
                    if (!owners.includes(sender))
                        throw new Error('Sender was not safe owner');
                    return [4 /*yield*/, getControllerFromModules(modules)];
                case 3:
                    if (_c.sent())
                        throw new Error("Pod module was already enabled. If you're trying to upgrade versions, use `Pod.migratePodToLatest` instead");
                    latestModule = (0, contracts_1.getDeployment)('ControllerLatest', config_1.config.network).address;
                    _c.label = 4;
                case 4:
                    _c.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, (0, create_safe_transaction_1.createSafeTransaction)({
                            sender: sender,
                            safe: safe,
                            to: safe,
                            data: (0, utils_1.encodeFunctionData)('GnosisSafe', 'enableModule', [latestModule])
                        })];
                case 5:
                    safeTx = _c.sent();
                    return [3 /*break*/, 7];
                case 6:
                    err_2 = _c.sent();
                    if (((_a = err_2.response) === null || _a === void 0 ? void 0 : _a.data.message) === 'Gas estimation failed') {
                        throw new Error('Gas estimation failed (this is often a revert error)');
                    }
                    throw err_2;
                case 7: return [4 /*yield*/, (0, transaction_service_1.approveSafeTransaction)(safeTx, signer)];
                case 8:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.enableController = enableController;
/**
 * Adds a Gnosis Safe to the pod ecosystem.
 * If a signer is not provided, it instead returns the unsigned transaction.
 * @param args.admin - Optional address of admin
 * @param args.name - ENS label for safe, i.e., 'orca-core'. Do not add the pod.eth/pod.xyz suffix
 * @param args.safe - Safe address
 * @param signer - Signer of a safe owner.
 * @throws - If Controller module was not enabled
 * @throws - If signer is not a safe owner
 * @returns
 */
function podifySafe(args, signer) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, owners, modules, _b, _c, _d, controllerDeployment, Controller, admin, MemberToken, expectedPodId, err_3;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, (0, transaction_service_1.getSafeInfo)(args.safe)];
                case 1:
                    _a = _e.sent(), owners = _a.owners, modules = _a.modules;
                    _b = signer;
                    if (!_b) return [3 /*break*/, 3];
                    _d = (_c = owners).includes;
                    return [4 /*yield*/, signer.getAddress()];
                case 2:
                    _b = !_d.apply(_c, [_e.sent()]);
                    _e.label = 3;
                case 3:
                    if (_b)
                        throw new Error('Sender was not safe owner');
                    return [4 /*yield*/, getControllerFromModules(modules)];
                case 4:
                    controllerDeployment = _e.sent();
                    if (!controllerDeployment)
                        throw new Error('Pod module was not enabled');
                    Controller = new ethers_1.ethers.Contract(controllerDeployment.address, controllerDeployment.abi, signer || config_1.config.provider);
                    admin = args.admin ? ethers_1.ethers.utils.getAddress(args.admin) : ethers_1.ethers.constants.AddressZero;
                    _e.label = 5;
                case 5:
                    _e.trys.push([5, 8, , 9]);
                    MemberToken = (0, utils_1.getMetropolisContract)('MemberToken', config_1.config.provider);
                    return [4 /*yield*/, MemberToken.getNextAvailablePodId()];
                case 6:
                    expectedPodId = (_e.sent()).toString();
                    if (signer)
                        return [2 /*return*/, Controller.createPodWithSafe(admin, args.safe, (0, ensjs_1.labelhash)(args.name), "".concat(args.name, ".").concat(config_1.config.network === 1 ? 'pod.xyz' : 'pod.eth'), expectedPodId, getImageUrl(expectedPodId))];
                    return [4 /*yield*/, Controller.populateTransaction.createPodWithSafe(admin, args.safe, (0, ensjs_1.labelhash)(args.name), "".concat(args.name, ".").concat(config_1.config.network === 1 ? 'pod.xyz' : 'pod.eth'), expectedPodId, getImageUrl(expectedPodId))];
                case 7: return [2 /*return*/, (_e.sent())];
                case 8:
                    err_3 = _e.sent();
                    return [2 /*return*/, (0, utils_1.handleEthersError)(err_3)];
                case 9: return [2 /*return*/];
            }
        });
    });
}
exports.podifySafe = podifySafe;
/**
 * Creates multiple pods simultaneously.
 *
 * Each pod requires an array of members, a threshold and label, with an optional admin.
 * Members or admins can be other pods in this create action.
 *
 * Pods can be added as members of other pods using labels,
 * but only with pods earlier up in the array.
 * I.e., the second pod in the array can have the first pod in the array as a member or admin,
 * but the first pod cannot have the second pod as a member.
 *
 * The label replacement does not (currently) work with already existing pods.
 *
 * An example:
 * ```
 *  [
 *   {
 *     label: 'orcanauts',
 *     // This will add the below pods as sub pods to this newly created one.
 *     members: ['art-nauts', 'gov-nauts'],
 *     threshold: 1,
 *   },
 *   {
 *     label: 'art-nauts',
 *     members: ['0x1234...', '0x2345...'],
 *     threshold: 1,
 *   },
 *   {
 *     label: 'gov-nauts',
 *     members: ['0x3456...', '0x4567...'],
 *     threshold: 1,
 *     // This will add the above 'orcanauts' pod as the admin to this new pod.
 *     admin: 'orcanauts',
 *   }
 * ]
 * ```
 * @param pods
 */
// eslint-disable-next-line import/prefer-default-export
function multiPodCreate(pods, signer) {
    return __awaiter(this, void 0, void 0, function () {
        var Controller, memberTokenDeployment, MemberToken, nextPodId, members, thresholds, admins, labels, ensNames, imageUrls, multiCreateDeployment, MultiCreate;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!config_1.config.network || !config_1.config.provider) {
                        throw new Error('Network/provider was not defined. Did you init the SDK?');
                    }
                    Controller = (0, contracts_1.getDeployment)('ControllerLatest', config_1.config.network);
                    memberTokenDeployment = (0, contracts_1.getDeployment)('MemberToken', config_1.config.network);
                    MemberToken = new ethers_1.ethers.Contract(memberTokenDeployment.address, memberTokenDeployment.abi, config_1.config.provider);
                    return [4 /*yield*/, MemberToken.getNextAvailablePodId()];
                case 1:
                    nextPodId = (_a.sent()).toNumber();
                    members = [];
                    thresholds = [];
                    admins = [];
                    labels = [];
                    ensNames = [];
                    imageUrls = [];
                    // The smart contract expects basically the reverse of what our SDK expects.
                    pods.reverse().forEach(function (pod) {
                        // Check if any of the members are labels.
                        members.push(pod.members.map(function (member) {
                            // If a member is not an eth address it (should) be a label.
                            if (!ethers_1.ethers.utils.isAddress(member)) {
                                var childPodIndex = pods.findIndex(function (findPod) { return findPod.label === member; });
                                if (childPodIndex < 0)
                                    throw new Error("No pod had the label of ".concat(member));
                                // We start the member array indexing at 1 because address 0 is reserved on the smart contract.
                                return createAddressPointer(childPodIndex + 1);
                            }
                            return member;
                        }));
                        if (!ethers_1.ethers.utils.isAddress(pod.admin)) {
                            if (!pod.admin)
                                admins.push(ethers_1.ethers.constants.AddressZero);
                            else {
                                var adminPodIndex = pods.findIndex(function (findPod) { return findPod.label === pod.admin; });
                                if (adminPodIndex < 0)
                                    throw new Error("No pod had the label of ".concat(pod.admin));
                                // We start the admin array indexing at 1, because address zero is reserved for the no-admin case.
                                admins.push(createAddressPointer(adminPodIndex + 1));
                            }
                        }
                        else {
                            // It's just an eth address, so we can push.
                            admins.push(pod.admin);
                        }
                        thresholds.push(pod.threshold);
                        labels.push((0, ensjs_1.labelhash)(pod.label));
                        if (config_1.config.network === '1') {
                            ensNames.push("".concat(pod.label, ".pod.xyz"));
                        }
                        else {
                            ensNames.push("".concat(pod.label, ".pod.eth"));
                        }
                        imageUrls.push(getImageUrl(nextPodId));
                        nextPodId += 1;
                    });
                    multiCreateDeployment = (0, contracts_1.getDeployment)('MultiCreateV1', config_1.config.network);
                    MultiCreate = new ethers_1.ethers.Contract(multiCreateDeployment.address, multiCreateDeployment.abi, signer);
                    return [2 /*return*/, MultiCreate.createPods(Controller.address, members, thresholds, admins, labels, ensNames, 
                        // We generate these independently of the incoming pods array, so it has to be manually reversed.
                        imageUrls.reverse())];
            }
        });
    });
}
exports.multiPodCreate = multiPodCreate;
